import { render, staticRenderFns } from "./EventOrderTag.vue?vue&type=template&id=74fe3d96&scoped=true"
import script from "./EventOrderTag.vue?vue&type=script&lang=js"
export * from "./EventOrderTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fe3d96",
  null
  
)

export default component.exports